import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fs-20 bold" }
const _hoisted_2 = { class: "fs-14 fc-grey mg-l-25 normal" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = { class: "fs-38 bold fc-pink text-center" }
const _hoisted_5 = { class: "flex flex-wrap" }
const _hoisted_6 = { class: "flex-item" }
const _hoisted_7 = { class: "flex-item" }
const _hoisted_8 = { class: "flex-item" }
const _hoisted_9 = { class: "fc-primary" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    "before-close": _ctx.handleClose
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.advanceData.userName) + "的预支单", 1),
        _createElementVNode("span", _hoisted_2, "身份证号：" + _toDisplayString(_ctx.advanceData.idCardNo), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex flex-jc-sb" }, [
          _createElementVNode("div", { class: "flex-1 fc-grey text-center" }, "申请预支金额")
        ], -1)),
        _createElementVNode("div", _hoisted_4, "¥" + _toDisplayString(_ctx.advanceData.advanceAmount), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "fc-light" }, "申请派遣单位：", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.advanceData.serveCompanyName), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "fc-light" }, "上次申请时间：", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.advanceData.lastAdvanceApplyTime || '--'), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fc-light" }, "上次申请金额：", -1)),
          _createElementVNode("span", _hoisted_9, [
            (_ctx.advanceData.advanceAmount || _ctx.advanceData.advanceAmount===0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "¥"))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.advanceData.advanceAmount || '--'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "fc-light" }, "预支备注：", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.advanceData.applyRemark || '--'), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}